import {
  RECEIVE_PURCHASE_ORDERS,
  CREATE_PURCHASE_ORDERS,
  REMOVE_PURCHASE_ORDERS,
  FILTER_PURCHASE_ORDERS
} from '../purchaseOrdersActionTypes';

export default function purchaseOrders(state = {}, action) {
  switch(action.type) {
    case RECEIVE_PURCHASE_ORDERS:
      return action.payload;
    case CREATE_PURCHASE_ORDERS:
      return state.concat(action.payload);
    case REMOVE_PURCHASE_ORDERS:
      return [];
    case FILTER_PURCHASE_ORDERS:
      return filterByStage(action.payload, state);
    default:
      return state;
  }
}

function filterByStage(value, collection) {
  if(value === '') return collection;

  if(value === 'action_required') {
    return collection.filter((item) => { return item.action_required === true; });
  } else {
    return collection.filter((item) => { return item.stage === value; });
  }
}



// WEBPACK FOOTER //
// ./src/features/trade_documents/reducers/purchaseOrdersReducer.js